import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlReceita = '/service/planejamentoEstrategico/indicadores/'

class PlanoEstrategicoIndicadoresService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getPlanoEstrategico() {
        return this.conex.get(urlReceita + 'todosPlanoEstrategico/')
    }
}

export default PlanoEstrategicoIndicadoresService
